// CV timeline data. Authored as markdown in content/cv/*.md and compiled to
// events.generated.json by scripts/build-cv.js (runs via the prestart /
// prebuild npm hooks). Already sorted newest-first by start date, so the app
// just imports and renders it.

import events from "./events.generated.json";

export default events;
